export const AnalyticsAction = {
  BI_INTENTO_ACCESO_LOGIN_VIEJO: 'BI_Intento_Acceso_Login_Viejo',
};